var _defs, _rect, _rect2, _text, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcharyamul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "acharyamulBg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E55934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C13B1F"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    result: "offsetBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offsetBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 38,
    fill: "url(#acharyamulBg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 172,
    height: 172,
    rx: 28,
    fill: "none",
    stroke: "rgba(255,255,255,0.12)",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 142,
    fontFamily: "'Noto Sans Devanagari', 'Mangal', 'Kohinoor Devanagari', 'Devanagari Sangam MN', sans-serif",
    fontSize: 155,
    fontWeight: 700,
    textAnchor: "middle",
    fill: "#FFFFFF",
    filter: "url(#softShadow)"
  }, "\u0906")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 180,
    r: 2.5,
    fill: "rgba(255,255,255,0.7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcharyamul);
export default __webpack_public_path__ + "static/media/acharyamul.1dd5095d0ebbe0c2666498511866a4d2.svg";
export { ForwardRef as ReactComponent };